import styled from "styled-components";
import { COLORS } from "../../../../../constants/Styles";

export const NoHistory = styled.div`
  color: ${COLORS.secondaryLight};
  text-align: center;
`;

export const Error = styled.div`
  color: ${COLORS.error};
  text-align: center;
`;

export const HistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
